export default __webpack_public_path__ + "assets/previous.4a6163a8.svg";